import { useEffect, useRef } from 'react';
import { HowItWorksIllustration } from './HowItWorksIllustration';

const BADGES = [
  { x:500, y:92, color:'#4a3aa8', icon:<><path d="M-23 -6 L0 -18 L23 -6 L0 6 Z" /><path d="M-13 1 V11 C-13 16 -6 19 0 19 C6 19 13 16 13 11 V1" /><path d="M23 -6 V9" /></> },
  { x:785.3, y:299.3, color:'#2e9e6b', icon:<><circle cx="-8" cy="-11" r="7.5" /><path d="M-21 19 C-21 7 -15 2 -8 2 C-1 2 5 7 5 19" /><circle cx="13" cy="-4" r="5.5" /><path d="M7 19 C7 11 10 7 13 7 C17 7 21 11 21 19" /></> },
  { x:676.3, y:634.7, color:'#e0a21b', icon:<><rect x="-23" y="-19" width="46" height="30" rx="5" /><path d="M-13 -9 H5 M-13 -1 H-3 M0 11 V21 M-11 21 H11" /><path d="M10 -6 l7 4 -7 4z" fill="currentColor" /></> },
  { x:323.7, y:634.7, color:'#dc5f7a', icon:<><path d="M-22 21 V-4 L0 -20 L22 -4 V21 M-27 21 H27 M-6 21 V7 H6 V21" /><circle cx="0" cy="-5" r="3.5" /></> },
  { x:214.7, y:299.3, color:'#3b2d8c', icon:<><path d="M-25 -7 L0 -21 L25 -7 Z M-17 -1 V13 M-6 -1 V13 M6 -1 V13 M17 -1 V13 M-25 21 H25 M-21 14 H21" /></> },
];

export const HowItWorksOrbit = ({ roles, current, onSelect }) => {
  const art = useRef(null);
  useEffect(() => {
    const fitLabels = () => art.current?.querySelectorAll('.lb').forEach(label => {
      const width = Math.max(100, label.querySelector('text').getBBox().width + 46);
      label.querySelector('rect').setAttribute('x', -width / 2);
      label.querySelector('rect').setAttribute('width', width);
    });
    document.fonts.ready.then(fitLabels);
    const observer = new ResizeObserver(fitLabels);
    observer.observe(art.current);
    return () => observer.disconnect();
  }, []);

  return (
    <svg ref={art} className="hiw-orbit" xmlns="http://www.w3.org/2000/svg" viewBox="95 -50 810 836" role="group" aria-label="مراحل النظام: الطالب، ولي الأمر، المعلم، إدارة المدرسة، الوزارة" data-testid="hiw-orbit">
      <HowItWorksIllustration />
      {BADGES.map((badge, index) => (
        <g key={index} transform={`translate(${badge.x} ${badge.y})`}>
          <g className="fb" style={{ animationDelay:`${index * -.9}s` }}>
            <g className="orbit-role" role="button" tabIndex={0} aria-label={roles[index].t} aria-pressed={current === index} aria-controls="hiw-role-detail" data-testid={`hiw-step-${index}`} onClick={() => onSelect(index)} onKeyDown={event => {
              if (event.key === 'Enter' || event.key === ' ') { event.preventDefault(); onSelect(index); }
            }} style={{ '--c':badge.color }}>
              <g className={`bd${current === index ? ' on' : ''}`}>
                <circle r="60" fill="#2a2150" opacity=".10" transform="translate(0 9)" />
                <circle className="pr" r="58" strokeWidth="4" />
                <circle className="tmr" r="67" transform="rotate(-90)" />
                <circle className="bc" r="58" /><circle className="bf" r="46" />
                <g stroke="currentColor" strokeWidth="3.4" fill="none" strokeLinecap="round" strokeLinejoin="round">{badge.icon}</g>
              </g>
              <g className={`lb${current === index ? ' on' : ''}`} transform={`translate(0 ${index === 0 ? -110 : 110})`} data-testid={`hiw-step-label-${index}`}>
                <rect x="-90" y="-23" width="180" height="46" rx="23" /><text y="9.5">{roles[index].t}</text>
              </g>
            </g>
          </g>
        </g>
      ))}
    </svg>
  );
};